module.exports = __webpack_public_path__ + "static/appStore-34d8a9aa560920666278004712fb22c1.png";